const SITE_ACCESS_KEY_PREFIX = "cuo_proposal_site_access:";

function envValue(key: string): string {
  const raw = import.meta.env[key];
  return typeof raw === "string" ? raw.trim() : "";
}

export function getProposalAccessCode(accessEnvKey: string): string | null {
  const accessCode = envValue(accessEnvKey);
  return accessCode || null;
}

export function usesProposalSiteAccess(accessEnvKey: string): boolean {
  return getProposalAccessCode(accessEnvKey) != null;
}

export function isValidProposalAccessCode(accessEnvKey: string, code: string): boolean {
  const accessCode = getProposalAccessCode(accessEnvKey);
  if (!accessCode) return false;
  const entered = code.trim();
  if (
    accessEnvKey === "VITE_PROPOSAL_JETS_ACCESS_CODE" ||
    accessEnvKey === "VITE_PROPOSAL_APRIL_ACCESS_CODE" ||
    accessEnvKey === "VITE_PROPOSAL_NORTH_ACCESS_CODE"
  ) {
    return entered.toLowerCase() === accessCode.toLowerCase();
  }
  return entered === accessCode;
}

export function hasStoredProposalAccess(slug: string): boolean {
  try {
    return sessionStorage.getItem(`${SITE_ACCESS_KEY_PREFIX}${slug}`) === "1";
  } catch {
    return false;
  }
}

export function storeProposalAccessSession(slug: string): void {
  try {
    sessionStorage.setItem(`${SITE_ACCESS_KEY_PREFIX}${slug}`, "1");
  } catch {
    // ignore quota / private mode
  }
}
